module.exports = __webpack_public_path__ + "images/header_about_abf14531ea1d322f18a486f2c1feb33c.jpg";